import React, { useEffect, } from "react";
import { useImmer } from "use-immer";
import {
  successMessage,
  errorMessage,
} from "../../../utils";
import { useParams } from "react-router-dom";
import {
  useDropdownApis,
} from "../../../shared";
import { assignStoresToProduct, deleteStoreFromProduct, getProductStores } from "../api";
import { tr } from "date-fns/locale";

export const useProductsStore = () => {
  const { id } = useParams();

  const {
    storeList,
  } = useDropdownApis({
    isStateWiseStoreList: true,
  });

  const [state, setState] = useImmer({
    isLoading: true,
    isSaveButton: false,
    dialogLoading: true,
    dataList: [],
    isOpen: false,
    isDeleteOpen: false,
    allDataList: [],
    filteredList: [],
    selectedItems: [],
    deleteModalOpen: false,
    selectedId: null,
    searchText: null,
  });

  useEffect(() => {
    if (id) { HandleProductsStores(id) }
  }, [id])


  const HandleProductsStores = async (id) => {

    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const res = await getProductStores(id);
      if (res.success) {
        setState((draft) => {
          draft.dataList = res.data;
          draft.selectedItems = res.data.map(item => item.id);
          draft.isLoading = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const HandleFilterStore = (type, text) => {

    if (type === "initial") {
      setState((draft) => {
        draft.searchText = "";
        draft.filteredList = state.allDataList;
        return draft;
      });
    } else {
      const Search = (data, text) => {
        text = text.toLowerCase();
        return data.map((val, i) => {
          let filtered = val.stores.filter((data) => {
            if (data.name.toString().toLowerCase().indexOf(text) > -1) return true;
          })
          return filtered.length ? { ...val, stores: filtered } : undefined
        }).filter(Boolean)
      };

      text = text.toLowerCase();
      setState((draft) => {
        draft.searchText = text;
        draft.filteredList = Search(state.allDataList, text)
        return draft;
      });
    }
  };


  const handleStoreSelect = (type, value, event) => {

    if (type === "all") {
      if (event.target.checked) {
        setState(draft => {
          draft.selectedItems = value.flatMap(cat =>
            cat.stores.map(prod => prod.id)
          );
        });

      } else {
        setState((draft) => {
          draft.selectedItems = []
        });
      }
    } else if (type === "body") {

      if (event.target.checked) {
        setState((draft) => {
          draft.selectedItems = [
            ...draft.selectedItems,
            value.id,
          ];
        });
      } else {
        setState((draft) => {
          draft.selectedItems =
            draft.selectedItems.filter(
              (val) => val !== value.id
            );
        });
      }
    }
    else {
      const subRowsID = value.stores?.map((e, i) => {
        return e.id;
      });
      if (event.target.checked) {
        setState((draft) => {
          draft.selectedItems = [
            ...new Set([...state.selectedItems, ...subRowsID]),
          ]
        });
      } else {
        setState((draft) => {
          draft.selectedItems =
            draft.selectedItems.filter(
              (val) => !subRowsID.includes(val)
            );
        });
      }
    }
  };

  useEffect(() => {
    HandleFilterStore("initial");
  }, [state.allDataList, state.dataList]);

  const handleAssignStoresToProduct = async () => {
    const data = {
      store_id: state.selectedItems,
    };
    setState((draft) => {
      draft.isSaveButton = true;
    });

    try {
      const res = await assignStoresToProduct(data, id);
      if (res.success === true) {
        successMessage(res.message);
        setState((draft) => {
          draft.dataList = [
            ...draft.dataList,
            ...draft.allDataList.filter((val) =>
              draft.selectedItems.includes(val.id)
            ),
          ];
          draft.isSaveButton = false;
          return draft;
        });
        handleModal("store-add", false);
        HandleProductsStores(id)
      }
    } catch (error) {
      setState((draft) => {
        draft.isSaveButton = false;
      });
      errorMessage(error.response.data.message);
    }
  };

  const handleDeleteStoreFromProduct = async () => {
    try {
      const res = await deleteStoreFromProduct(
        id,
        state.selectedId
      );
      if (res.success) {
        successMessage("Deleted Successfully");
        setState((draft) => {
          draft.dataList = draft.dataList.filter(
            (item) => item.id !== state.selectedId
          );
          draft.selectedItems = draft.selectedItems.filter(
            (id) => id !== state.selectedId
          );
        });
        handleModal("store-from-product", false, null);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  useEffect(() => {

    setState((draft) => {
      draft.allDataList = getStoresGroupedByState(storeList);
      draft.dialogLoading = false;
    });
  }, [storeList]);

  function getStoresGroupedByState(stores) {
    const grouped = {};

    stores.forEach(store => {
      if (!grouped[store.state_name]) {
        grouped[store.state_name] = {
          state_id: store.state_id,
          state_name: store.state_name,
          stores: []
        };
      }
      grouped[store.state_name].stores.push(store);
    });

    return Object.values(grouped);
  }

  const handleModal = (type, state, data) => {
    switch (type) {
      case "store-add":
        if (!state) {
          setState((draft) => {
            draft.isOpen = state;
          });
        } else {
          setState((draft) => {
            draft.isOpen = state;
          });
        }
        break;
      case "store-from-product":
        setState((draft) => {
          draft.isDeleteOpen = state;
          draft.selectedId = data;
        });
        break;
    }
  };

  return {
    state,
    HandleFilterStore,
    handleStoreSelect,
    handleAssignStoresToProduct,
    handleDeleteStoreFromProduct,
    handleModal,
  }
};
